const HEARTBEAT_BASE_URL = "https://schellbrothers.com";
const SAVED_PLAN_VIEW_URL = `https://heartbeat.schellbrothers.com/?engine=data-warehouse&widget=marketing-user-actions-explorer&opt=view-saved-plan&id=`;

export const getFloorPlanActivityUrl = (activity = {}) => {
  const {
    activity_type,
    url,
    saved_plan_configuration_id,
  } = activity;
  const trimmedUrl = (url || "").trim();

  if (activity_type === "SAVE_FLOOR_PLAN") {
    if (
      saved_plan_configuration_id
      && (!trimmedUrl || !trimmedUrl.includes("opt=view-saved-plan&id="))
    ) {
      return `${SAVED_PLAN_VIEW_URL}${saved_plan_configuration_id}`;
    }

    return trimmedUrl;
  }

  if (activity_type === "FAVORITE_FLOOR_PLAN") {
    if (
      trimmedUrl
      && trimmedUrl.startsWith("/")
      && !/^https?:\/\//i.test(trimmedUrl)
    ) {
      return `${HEARTBEAT_BASE_URL}${trimmedUrl}`;
    }

    return trimmedUrl;
  }

  return trimmedUrl;
};
